import { render } from "./ElementForm.vue?vue&type=template&id=a714963e&scoped=true"
import script from "./ElementForm.vue?vue&type=script&lang=js"
export * from "./ElementForm.vue?vue&type=script&lang=js"

import "./ElementForm.vue?vue&type=style&index=0&id=a714963e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a714963e"]])

export default __exports__